import React, { useState } from 'react';
import api from '../../services/api';
import './ConsultaPage.css';

// Formulario PÚBLICO de consulta (sin login). Se comparte por link en
// Instagram/WhatsApp/web de LANG; cada envío entra como lead 'nuevo'.
// Mínimo a propósito: nombre + WhatsApp + tipo de evento (un toque) y enviar.
const EVENT_TYPES = ['Corporativo', 'Casamiento', 'Cumpleaños', 'Show / Fiesta', 'Otro'];

// Origen del lead según el link compartido: /consulta?source=instagram (bio de
// IG), ?source=whatsapp, etc. Sin parámetro queda 'web'.
function sourceFromUrl() {
  const s = new URLSearchParams(window.location.search).get('source');
  return ['instagram', 'whatsapp', 'otro'].includes(s) ? s : 'web';
}

export default function ConsultaPage() {
  const [form, setForm] = useState({ contact_name: '', phone: '', event_type: '', website: '' });
  const [sent, setSent] = useState(false);
  const [sending, setSending] = useState(false);
  const [error, setError] = useState('');
  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  async function submit(e) {
    e.preventDefault();
    if (!form.contact_name.trim() || !form.phone.trim()) {
      setError('Dejanos tu nombre y un WhatsApp para contactarte.');
      return;
    }
    setError('');
    setSending(true);
    try {
      await api.post('/leads/intake', { ...form, source: sourceFromUrl() });
      setSent(true);
    } catch (err) {
      setError(err.response?.data?.error || 'No se pudo enviar. Probá de nuevo en un momento.');
    } finally {
      setSending(false);
    }
  }

  return (
    <div className="cst-page">
      <div className="cst-card">
        <img src="/logo.png" alt="LANG" className="cst-logo" />
        {sent ? (
          <div className="cst-done">
            <div className="cst-done-icon">✓</div>
            <h1>¡Listo!</h1>
            <p>Te escribimos por WhatsApp a la brevedad.</p>
          </div>
        ) : (
          <>
            <h1>Contanos tu evento</h1>
            <p className="cst-sub">Toma 20 segundos. Te contactamos nosotros.</p>
            <form onSubmit={submit} className="cst-form">
              <input
                value={form.contact_name}
                onChange={e => set('contact_name', e.target.value)}
                maxLength={200}
                autoComplete="name"
                placeholder="Tu nombre o empresa"
              />
              <input
                value={form.phone}
                onChange={e => set('phone', e.target.value)}
                maxLength={60}
                autoComplete="tel"
                inputMode="tel"
                placeholder="WhatsApp"
              />
              <div className="cst-chips" role="group" aria-label="Tipo de evento">
                {EVENT_TYPES.map(t => (
                  <button
                    key={t}
                    type="button"
                    className={`cst-chip${form.event_type === t ? ' on' : ''}`}
                    onClick={() => set('event_type', form.event_type === t ? '' : t)}
                  >{t}</button>
                ))}
              </div>
              {/* Honeypot anti-bots: oculto para humanos */}
              <input className="cst-hp" tabIndex={-1} autoComplete="off" value={form.website} onChange={e => set('website', e.target.value)} placeholder="website" aria-hidden="true" />
              {error && <div className="cst-error">{error}</div>}
              <button type="submit" disabled={sending}>{sending ? 'Enviando…' : 'Enviar'}</button>
            </form>
          </>
        )}
        <div className="cst-foot">LANG · producción de eventos</div>
      </div>
    </div>
  );
}
